import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import { Link, NavLink, useParams } from "react-router-dom";

const ProjectRequest = ({ }) => {

    const { apiURL, apiHeaderJson, user_profile_id } = useContext(ConfigContext);
    const [consultantRequest, setConsultantRequest] = useState([]);

    const { project_id, } = useParams();

    const getAllRequests = async () => {
        try {

            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/GetDashboardForClient`, { params: { client_id: user_profile_id }, headers })
            const { data, success } = response.data;
            if (success === true) {
                const req = data.tabs.projects_requests;

                setConsultantRequest(req.filter((row) => Number(row?.project_id) === Number(project_id)))

            }
        } catch (error) {
            console.log(error);
        }
    }

    const Labels = (status) => {
        if (status === 0) {
            return "Pending";
        } else if (status === 1) {
            return "Approved";
        } else if (status === 2) {
            return "Revise";
        }
        else if (status === 3) {
            return "Rejected";
        }
        else if (status === 4) {
            return "In-Clearence";
        }

    };
    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning";
        } else if (status === 1) {
            return "badge bg-success-subtle text-success";
        } else if (status === 2) {
            return "badge bg-info-subtle text-info";
        } else if (status === 3) {
            return "badge bg-danger-subtle text-danger";
        } else if (status === 4) {
            return "badge bg-secondary-subtle text-secondary";
        }
    };

    // useEffect(() => {
    //     getAllRequests()
    // }, [])

    return (

        <div className="col-xxl-12">
            <div className="card">
                <div className="card-body">
                    <div className="card-header d-flex align-items-center mb-4">
                        <h5 className="card-title flex-grow-1 mb-0">Project Request </h5>

                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table table-borderless align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-center" width="28%">
                                                Project Name
                                            </th>
                                            <th className="text-center" width="25%">
                                                Item Name
                                            </th>
                                            <th className="text-center" width="15%">
                                                Quantity
                                            </th>
                                            <th className="text-center" width="15%">
                                                Price(QAR)
                                            </th>
                                            <th className="text-center" width="10%">
                                                Status
                                            </th>
                                            <th className="text-center" width="14%">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    {consultantRequest.length !== 0 ? (
                                        <tbody>
                                            {
                                                consultantRequest.map((row) => (
                                                    <tr key={row.category_id}>
                                                        <td className="text-center">
                                                            <NavLink to={`/ProjectProfile/${row?.project_id}`}>{row?.project_title}</NavLink>
                                                        </td>
                                                        <td className="text-center">
                                                            {row?.item_name ?? "-"}
                                                        </td>
                                                        <td className="text-center">
                                                            {row?.pi_item_qty ?? "-"}
                                                        </td>
                                                        <td className="text-center">
                                                            {row?.pi_item_price ?? "-"}
                                                        </td>
                                                        {row?.consultant_given_status ?
                                                            <td className="text-center">
                                                                <span className={Classes(row?.consultant_given_status)}>
                                                                    {Labels(row.consultant_given_status)}
                                                                </span>
                                                            </td>
                                                            : <td className="text-center">
                                                                <span className={Classes(row.request_status)}>
                                                                    {Labels(row.request_status)}
                                                                </span>
                                                            </td>}
                                                        <td className="d-flex justify-content-around">

                                                            <Link to={`/PreviewStatus/${row?.project_request_id}`}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link text-info fs-18 p-0"

                                                                >
                                                                    <i className=" ri-eye-line" />
                                                                </button>
                                                            </Link>



                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            <tr>
                                                <td colSpan="8">
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ProjectRequest;